import { createContext, useContext, type ReactNode } from "react";

// Use the built-in object type for an empty context value
type GlobalModalContextType = object;

const GlobalModalContext = createContext<GlobalModalContextType | undefined>(undefined);

export function useGlobalModal() {
    const context = useContext(GlobalModalContext);
    if (context === undefined) {
        throw new Error("useGlobalModal must be used within a GlobalModalProvider");
    }
    return context;
}

interface GlobalModalProviderProps {
    children: ReactNode;
}

export function GlobalModalProvider({ children }: GlobalModalProviderProps) {
    const value: GlobalModalContextType = {
        // Future global modal controls would go here
    };

    return <GlobalModalContext.Provider value={value}>{children}</GlobalModalContext.Provider>;
}
